module.exports = __webpack_public_path__ + "img/Water_Potion.89052341.png";